/*
 *
 * generates "themeable" mixin on the fly...
 *
 */
export default function (options, name = 'theme') {
  const $$property = name
  const $$computed = `${name}__cssClasses`
  const $$template = `${name}--{option}`
  return {

    props: {

      [$$property]: {
        type: String,
        default: options[0],
        validator: (value) => options.includes(value),
      },
    },

    computed: {

      // @returns Array css classes
      [$$computed] () {
        // choosen option
        const option = this[$$property]
        // css class name for option
        const cssClass = $$template.replace('{option}', option)
        // return css class if exist...
        return (this.$style && Object.prototype.hasOwnProperty.call(this.$style, cssClass))
          ? [this.$style[cssClass]]
          : []
      },
    },
  }
}
